import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { Box } from '@chakra-ui/react';

import Modal from '../components/Modal';
import CertHolderUserPage from '../pages/InsuranceRequests/CertHolderUserPage';
import InsuranceRequestHeader from '../pages/InsuranceRequests/components/InsuranceRequestHeader';
import MigrationRedirectPage from '../pages/InsuranceRequests/MigrationRedirectPage';
import StandbyVerificationPage from '../pages/InsuranceRequests/StandbyVerificationPage';
import SubmissionPage from '../pages/InsuranceRequests/SubmissionPage';
import ConfirmationPage from '../pages/InsuranceRequests/SubmissionPage/ConfirmationPage';
import VerifyEmailPage from '../pages/InsuranceRequests/VerifyEmailPage';
import NoMatchPage from '../pages/NoMatchPage';
import { appMounted } from '../redux/modules/app';
import { getContentHeightString } from '../styles/layoutDimensions';

const InsuranceRequestRoutes = () => {
  const dispatch = useDispatch();
  const { path } = useRouteMatch();

  useEffect(() => {
    dispatch(appMounted());
  }, [dispatch]);

  return (
    <Box id="insurance-request-page-container">
      <InsuranceRequestHeader />
      <Box sx={{ minH: getContentHeightString() }}>
        <Switch>
          <Route
            component={VerifyEmailPage}
            path={`${path}/verify`}
          />
          <Route
            component={SubmissionPage}
            path={`${path}/submission`}
          />
          <Route
            component={ConfirmationPage}
            path={`${path}/confirmation`}
          />
          <Route
            component={StandbyVerificationPage}
            path={`${path}/email-verification`}
          />
          <Route
            component={MigrationRedirectPage}
            path={`${path}/migrationAgentRedirect`}
          />
          <Route
            component={CertHolderUserPage}
            path={`${path}/cert-holder-user`}
          />
          <Route
            component={NoMatchPage}
            path={`${path}/*`}
          />
        </Switch>
        <Modal />
      </Box>
    </Box>
  );
};

export default InsuranceRequestRoutes;
